import React, { ReactNode } from 'react';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { cssTheme } from '../../../themes';
import { Radio } from '../Radio';
import { Text } from '../Text';
export type RadioCardSize = Extract<SizesType, 'md' | 'lg'>;
interface Props {
  /** Whether the radio is checked or not */
  checked: boolean;
  /** RadioCard content */
  children: ReactNode;
  /** The Radio change handler. Fires when user change state of Radio */
  onChange: () => void;
  /** Pass through className to allow styles overrides */
  className?: string;
  /** ID for end to end testing and Fullstory monitoring */
  dataId?: string;
  /** Name used for html input element */
  name?: string;
  /** An Icon to display on the left side */
  iconStart?: ReactNode;
  /** Value used for html input element */
  value?: string;
  /** Size variant */
  size?: RadioCardSize;
}
interface StyleProps {
  checked: boolean;
  size: RadioCardSize;
}
const _exp2 = /*#__PURE__*/() => ({
  size
}) => size === 'md' ? `${cssTheme.layout.spacing.s400} ${cssTheme.layout.spacing.s300}` : `${cssTheme.layout.spacing.s500} ${cssTheme.layout.spacing.s400}`;
const _exp5 = /*#__PURE__*/() => ({
  checked
}) => checked ? cssTheme.colors.border.interactive.c800 : cssTheme.colors.border.neutral.c200;
const _exp6 = /*#__PURE__*/() => ({
  checked
}) => checked ? `0px 0px 0px 1px ${cssTheme.colors.border.interactive.c500}` : 'none';
const _exp7 = /*#__PURE__*/() => ({
  checked
}) => checked ? cssTheme.colors.background.interactive.c050 : cssTheme.colors.background.neutral.c000;
const LabelStyled = /*#__PURE__*/styled('label')({
  name: "LabelStyled",
  class: "l1u8um52",
  propsAsIs: false,
  vars: {
    "l1u8um52-0": [_exp2()],
    "l1u8um52-1": [_exp5()],
    "l1u8um52-2": [_exp6()],
    "l1u8um52-3": [_exp7()]
  }
});
export const RadioCard = ({
  children,
  checked,
  onChange,
  dataId = 'RadioCard',
  iconStart,
  name = 'RadioCard',
  value,
  size = 'lg',
  className
}: Props) => <LabelStyled checked={checked} size={size} className={className}>
    <Radio name={name} dataId={dataId} checked={checked} onChange={onChange} value={value} />
    {iconStart}
    <div>
      <Text variant={size === 'md' ? 'bodyS' : 'bodyM'} colorPath="content.neutral.c950">
        {children}
      </Text>
    </div>
  </LabelStyled>;

require("./RadioCard.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RadioCard.tsx");